import { BookAppointmentRequest, Urls } from '@2meters/types'
import { functions } from 'api/Firebase/firebase-init'
import { httpsCallable } from 'firebase/functions'

export function bookAppointment(request: BookAppointmentRequest) {
  const bookAppointmentCloudFunc = httpsCallable(
    functions,
    `${Urls.visitor.prefix}${Urls.visitor.bookAppointment}`
  )

  return bookAppointmentCloudFunc(request)
}
